import * as React from 'react'
import { isUserAuthenticated } from '$services/session/isAuthenticated/isAuthenticated.service'
import { PrivateHeader } from '$views/components/Layout/PrivateHeader'
import { PublicHeader } from '$views/components/Layout/PublicHeader'
import { Container } from '$views/components/Layout/Container'
import { FormContainer } from '$views/components/FormContainer'
import { ServiceInformationStep } from '$views/RecommendationsForms/BroadcastForm/ServiceInformationStep'
import { ContactStep } from '$views/RecommendationsForms/BroadcastForm/ContactStep'
import { userGroupService } from '$utils/services/userGroupService'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { tagManager } from '$infrastructure/tagManager/tagManager'

export const broadcastFormSteps = {
  serviceInformationStep: {
    careInformation: 'careInformation',
    location: 'location',
    phoneNumber: 'phoneNumber',
    careType: 'careType',
    hoursPerWeek: 'hoursPerWeek',
  },
  contactStep: 'contactStep',
}

export const orderedBroadcastFormSteps = [broadcastFormSteps.serviceInformationStep, broadcastFormSteps.contactStep]

export const broadcastFormDraftName = 'broadcastForm'

export const BroadcastForm: React.FC = () => {
  const [currentStep, setStep] = React.useState<number>(0)

  React.useEffect(() => {
    if (isUserAuthenticated() && !userGroupService.isNormalCustomer()) {
      history.push(routeProvider.myServices)
    }

    tagManager.push({
      event: 'startform',
      offerType: 'broadcast',
    })
  }, [])

  const onNextStep = () => {
    setStep(step => step + 1)
  }

  const convertStepToNumber = step => orderedBroadcastFormSteps.findIndex(orderedSteps => orderedSteps === step)

  return (
    <>
      {isUserAuthenticated() ? <PrivateHeader secondLevel /> : <PublicHeader />}
      <Container>
        <FormContainer login>
          {currentStep === convertStepToNumber(broadcastFormSteps.serviceInformationStep) && (
            <ServiceInformationStep onNextStep={onNextStep} />
          )}
          {currentStep === convertStepToNumber(broadcastFormSteps.contactStep) && <ContactStep />}
        </FormContainer>
      </Container>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/BroadcastForm.tsx